var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 28954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.60938 6.48438C1.27283 6.48438 1 6.21155 1 5.875C1 5.53845 1.27283 5.26562 1.60938 5.26562C1.94592 5.26562 2.21875 5.53845 2.21875 5.875C2.21875 6.21155 1.94592 6.48438 1.60938 6.48438Z",
    fill: "#425364",
    stroke: "#425364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.60938 2.21875C1.27283 2.21875 1 1.94592 1 1.60938C1 1.27283 1.27283 1 1.60938 1C1.94592 1 2.21875 1.27283 2.21875 1.60938C2.21875 1.94592 1.94592 2.21875 1.60938 2.21875Z",
    fill: "#425364",
    stroke: "#425364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.60938 10.75C1.27283 10.75 1 10.4772 1 10.1406C1 9.80408 1.27283 9.53125 1.60938 9.53125C1.94592 9.53125 2.21875 9.80408 2.21875 10.1406C2.21875 10.4772 1.94592 10.75 1.60938 10.75Z",
    fill: "#425364",
    stroke: "#425364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.21663e213702b2073c8996295b01291b.svg";
export { ForwardRef as ReactComponent };